<template>
  <div class="sn-f-b-s pathology">
    <sn-navigator id="BGCX"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s pathology-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_BLBG) }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 pathology-blank">
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>就诊人：</div>
            </div>
            <div v-if="!$sn.validate.array(patientArray)" @click="handlePatientInfo();">
              暂未获取到就诊人，<span class="sn-pointer sn-fc-main">点击刷新</span>
            </div>
            <template v-else-if="patientArray.length === 0">
              <div @click="navigateUrl('addition-patient');">
                暂无就诊人，<span class="sn-pointer sn-fc-main">点击添加</span>
              </div>
            </template>
            <template v-else>
              <el-select :value="selectedPatient.patientId" @change="changePatient">
                <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientArray"></el-option>
              </el-select>
            </template>
          </div>

          <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? '证件号' : '就诊卡' }}：</div>
            </div>
            <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
              {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
            </div>
            <div v-else>
              <el-input readonly="readonly" v-model="outCardSerialFormat"></el-input>
            </div>
          </div>
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>日期范围：</div>
            </div>
            <el-date-picker v-model="startDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">-</div>
          <div class="sn-f-s-c region">
            <el-date-picker v-model="endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">
            <el-button type="primary" @click="searchBtn">查询</el-button>
          </div>
        </div>
        <template v-if="!$sn.validate.empty(handlePathology)">
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>就诊人</th>
                  <th>身份证号</th>
                  <th>手机号</th>
                  <th>性别</th>
                  <th>报告名称</th>
                  <th>检查时间</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(pathology, index) in handlePathology">
                  <td>{{ index + 1 }}</td>
                  <td>{{selectedPatient.patientName}}</td>
                  <td>{{$sn.encrypted.idCardSerial(selectedPatient.patientIdCardNo)}}</td>
                  <td>{{selectedPatient.phoneEncrypt}}</td>
                  <td>{{$sn.format.sex(selectedPatient.patientSex)}}</td>
                  <td class="alone-width">{{pathology.itemClass}}</td>
                  <td>{{pathology.checkTime}}</td>
                  <td class="sn-pointer sn-fc-main" @click="navigateUrl('/query/pathology/detail', pathology);">查看详情</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
        </template>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(pathologyInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
      <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
      <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" @sendBack="sendBackBindCard"></bind-card>
    </div>
    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import self from '@/common/utils/global-config';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';

export default {
  mixins: [PatientShareMixin],

  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },

  data() {
    return {
      reportType: '', // 报告类型
      patientArray: [], // 就诊人列表
      selectedPatient: {}, // 当前就诊人
      outCardSerial: '', // 就诊卡号
      outCardSerialFormat: '', // 就诊卡号格式化
      startDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', self.$sn.getConfig('pcPrescriptionDateRange')[0], self.$sn.getConfig('pcPrescriptionDateRange')[1]), // 开始日期
      endDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'), // 结束日期
      pathologyInfo: [], // 报告列表
      pageCount: 1, // 当前页码
      isResult: true, // 是否查询到结果
      exhibitionCreatePatient: false, // 是否显示创建就诊人
      exhibitionBindCard: false // 是否显示绑定就诊卡
    };
  },

  computed: {
    // 处理报告信息
    handlePathology() {
      let handle = [];
      if (this.pathologyInfo.length > 0) handle = this.$sn.format.group(this.pathologyInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      return handle;
    }
  },

  watch: {
    // 切换就诊人
    selectedPatient: async function(patient) {
      this.isResult = true;
      this.pathologyInfo = [];
      this.pageCount = 1;
      if (patient.patientId) {
        const handle = await Tools.handlePatientInfo(patient);
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) {
            this.outCardSerialFormat = patient.idCardEncrypt;
          }
        }
        if (this.outCardSerial) this.searchBtn();
        else {
          const compare = {
            [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
          };
          this.$sn.assembly.modal({
            caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
            success: (modal) => {
              if (modal.confirm) {
                this.navigateUrl('addition-card');
              }
            }
          });
        }
      }
    },

    $route(val, old) {
      if ((old.path === '/query/pathology' && val.path !== '/query/pathology/detail') || (old.path === '/query/pathology/detail' && val.path !== '/query/pathology')) {
        this.initialPathology();
      }
    },

    // 切换页码
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || !this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.pathologyInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.searchBtn();
        }
      },
      immediate: true
    }
  },

  created() {
    this.initialPathology();
  },

  methods: {
    // 初始化病理报告
    initialPathology() {
      document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_BLBG);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_BLBG);

      this.reportType = this.$route.query.type || '1';
      // 温馨提示
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDQL) {
        let caption = Messages.SEARCH049;
        if (this.reportType === '2') {
          caption = Messages.SEARCH050;
        }
        this.$sn.assembly.modal({
          caption: caption,
          captionConfirm: '已了解',
          isCancel: false
        });
      }
      this.handlePatientInfo();
    },

    // 处理就诊人信息
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList') || [];
      if (this.patientArray && this.patientArray.length > 0) this.selectedPatient = this.$sn.utils.getCurrentPatient();
    },

    // 切换就诊人
    changePatient(id) {
      if (id) {
        this.selectedPatient = this.patientArray.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    // 添加就诊人回调
    sendBackCreatePatient(type) {
      if (type) this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      this.exhibitionCreatePatient = false;
    },
    // 绑卡回调
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    // 查询病理报告
    searchBtn() {
      this.isResult = true;
      if (!this.outCardSerial) {
        const compare = {
          [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
        };
        this.$sn.assembly.modal({
          caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
          success: (modal) => {
            if (modal.confirm) this.navigateUrl('addition-card');
          }
        });
      }
      else {
        if (this.$sn.validate.empty(this.startDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['开始日期']));
          return false;
        }
        if (this.$sn.validate.empty(this.endDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['结束日期']));
          return false;
        }
        const start = new Date(this.startDate).getTime();
        const end = new Date(this.endDate).getTime();
        if (end < start) {
          this.getShowToast('结束日期不能早于开始日期');
          return false;
        }
        const getCheckList = () => {
          const params = {
            url: Swagger.getCheckTable,
            method: 'POST',
            header: true,
            data: JSON.stringify({
              hosId: this.$sn.utils.getHospitalId(),
              page: this.pageCount,
              patId: this.selectedPatient.patientId,
              platformId: this.$sn.utils.getPlatformType(),
              platformUserId: this.$sn.utils.getOpenId(),
              projectType: this.$sn.utils.getProjectType(),
              sheetType: this.reportType === '1' ? '0' : '1', // 0:门诊 1:住院
              size: this.perpetual.PAGINATION_SIZE,
              cardNo: this.outCardSerial,
              endDate: this.endDate,
              startDate: this.startDate,
              type: 'BLBG'
            })
          };
          this.$sn.assembly.loading(true);
          this.$sn.utils.ordinaryRequest(params).then(result => {
            this.$sn.assembly.loading(false);
            if (result && result.code === 0 && result.data && result.data.length > 0) {
              this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
              if (this.pageCount === 1) this.pathologyInfo = result.data;
              else this.pathologyInfo = this.pathologyInfo.concat(result.data);
            }
            else this.isResult = false;
          });
        };
        if (this.isResult) getCheckList();
      }
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.pathologyInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    // 跳转页面
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/query/pathology/detail' && !this.$sn.validate.empty(item)) {
        item.cardNo = this.outCardSerial;
        this.$sn.utils.setHospitalSessionStorage('Pathology_Info', {
          ...item,
          patient: this.selectedPatient
        });
      }
      if (url === 'addition-patient') this.exhibitionCreatePatient = true;
      else if (url === 'addition-card') this.exhibitionBindCard = true;
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  },
  beforeDestroy() {
    if (this.$sn.utils.getHospitalSessionStorage('Pathology_Info')) {
      this.$sn.utils.removeHospitalSessionStorage('Pathology_Info');
    }
  }
};
</script>
<style lang="scss" scoped>
.pathology {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .pathology-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;

      ::v-deep .sn-header-patient {
        .el-date-editor.el-input {
          width: 130px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
      }

      .el-button {
        padding: 10px 20px;
        background-color: $main1;
        border-color: $main1;
      }

      .sn-table {
        td {
          max-width: 200px;
        }

        .alone-width {
          max-width: 250px;
        }
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
